export const BOOSTER_OFFER_STATS_ONE_OF_LAST_THRESHOLD = 2;
export const BOOSTER_OFFER_STATS_ONE_OF_LAST_THRESHOLD = 2;
